<template>
    <div class="AddMeetEmergencyRanksBox">
        <div class="head">
            <el-breadcrumb style="margin: auto auto auto 20px;" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: 'meetEmergencyRanks' }">应急队伍管理</el-breadcrumb-item>
                <el-breadcrumb-item>{{ $route.params.key ? '编辑' : '新增' }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="content">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px"
                     size="small" style="width: 55%; margin-left: 15%">
                <el-form-item label="队伍名称" prop="name">
                    <el-input v-model="ruleForm.name"/>
                </el-form-item>
                <el-form-item label="队伍级别" prop="rankLevel">
                    <el-select v-model="ruleForm.rankLevel" style="width: 100%" placeholder="请选择">
                        <el-option v-for="item in rankList" :key="item" :value="item" :label="item"/>
                    </el-select>
                </el-form-item>
                <el-form-item label="队伍负责人" prop="responsiblePersonName">
                    <el-input v-model="ruleForm.responsiblePersonName"/>
                </el-form-item>
                <el-form-item label="负责人部门" prop="responsiblePersonDep">
                    <el-input v-model="ruleForm.responsiblePersonDep"/>
                </el-form-item>
                <el-form-item label="负责人手机" prop="responsiblePersonCellphone">
                    <el-input v-model="ruleForm.responsiblePersonCellphone" type="number"/>
                </el-form-item>
                <el-form-item label="固定电话">
                    <el-input v-model="ruleForm.responsiblePersonTel"/>
                </el-form-item>
                <el-form-item label="队伍描述">
                    <el-input v-model="ruleForm.descride" type="textarea" :rows="3"/>
                </el-form-item>
                <el-form-item label="成员" prop="member">
                    <el-select v-model="ruleForm.member" multiple placeholder="请选择" style="width: 100%">
                        <el-option v-for="item in memberList" :value-key="item.id" :value="item.id" :key="item.id"
                                   :label="item.name">
                            <span style="float: left">{{ item.name }}</span>
                            <span style="float: right; color: #8492a6; font-size: 13px">{{ item.companyName }}</span>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="相关附件">
                    <el-upload
                            class="upload-demo"
                            action="/v1/trainMaterials/uploadFile"
                            :on-remove="handleRemove"
                            :limit="1"
                            :on-exceed="handleExceed"
                            :on-change="handleChange"
                            :file-list="fileList">
                        <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item label="">
                    <el-button type="primary" style="width: 100%" @click="submit">保存</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import {getStaffList, meetEmerRanksAdd, meetEmerRanksEdit} from '@/api/processManager'

    export default {
        name: 'AddMeetEmergencyRanks',
        data() {
            return {
                ruleForm: {
                    member: []
                },
                rules: {
                    name: [{required: true, message: '请输入'}],
                    rankLevel: [{required: true, message: '请选择'}],
                    responsiblePersonName: [{required: true, message: '请输入'}],
                    responsiblePersonDep: [{required: true, message: '请输入'}],
                    responsiblePersonCellphone: [{required: true, message: '请输入'}],
                    member: [{required: true, message: '请选择', trigger: 'blur'}],
                },
                rankList: ['公司', '分厂—车间', '工序—班组'],
                fileList: [],
                memberList: []
            }
        },
        async created() {
            await this.getMemberList()
            if (this.$route.params.key) {
                this.ruleForm = this.$route.params.key
                if (this.$route.params.key.fileUrl) {
                    this.fileList.push({
                        name: this.$route.params.key.fileName,
                        response: {data: this.$route.params.key.fileUrl}
                    })
                }
                let arr = this.$route.params.key.member.split(',')
                let newArr = []
                arr.forEach(item => {
                    newArr.push(Number(item))
                })
                this.ruleForm.member = newArr
            }
        },
        methods: {
            // 获取员工列表
            async getMemberList() {
                await getStaffList().then(res => {
                    this.memberList = res.body.data
                })
            },
            handleRemove(file, fileList) {
                this.fileList = fileList
            },
            handleChange(file, fileList) {
                this.fileList = fileList
            },
            handleExceed(file, fileList) {
                this.$message.warning('限制上传一个文件')
            },
            submit() {
                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        let obj = {...this.ruleForm}
                        if (this.fileList.length > 0) {
                            obj.fileName = this.fileList[0].name
                            obj.fileUrl = this.fileList[0].response.data
                        } else {
                            obj.fileName = '',
                                obj.fileUrl = ''
                        }
                        // 人员数据处理
                        obj.member = this.ruleForm.member.join(',')
                        // 编辑
                        if (this.$route.params.key) {
                            meetEmerRanksEdit({...obj}).then(res => {
                                this.$message.success('编辑成功')
                                this.$router.push('meetEmergencyRanks')
                            })
                        }
                        // 新增
                        else {
                            meetEmerRanksAdd({...obj}).then(res => {
                                this.$message.success('新增成功')
                                this.$router.push('meetEmergencyRanks')
                            })
                        }
                    } else {
                        return false;
                    }
                });
            }
        },
        deactivated() { //路由组件失活时时执行函数
            this.$destroy() //路由组件失活时 销毁组件 再次打开重载组件
        }
    }
</script>

<style scoped>
    .AddMeetEmergencyRanksBox /deep/ .el-form-item {
        margin-bottom: 25px
    }
</style>
